var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-container"},_vm._l((_vm.notifications),function(notification){return _c('div',{key:notification.id,class:['notification', 'notification-' + notification.type]},[_vm._v("\n        "+_vm._s(notification.text)+"\n    ")])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1434e9c3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Common/NotificationContainer.vue
// module id = 754
// module chunks = 0 1